<template>
    <div class="item-cell" @mouseover="isHovering = true" @mouseleave="isHovering = false">
        <span class="text-primary" style="cursor: pointer;">{{ items.length }} {{ $t('items') }}</span>
        <div v-if="isHovering && items.length" class="items-popover">
            <h6 class="popover-header">{{ $t('event_items') }}</h6>
            <div class="popover-body">
                <div v-for="(item, index) in items" :key="index" class="item-detail mb-2">
                    <p class="mb-0"><strong>{{ item.title  ?? item.employee_name}}</strong> ({{ $t(item.category) }})</p>
                    <p v-if="item.description" class="text-muted small mb-0">{{ item.description }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ItemListView',
    props: {
        value: { // 'value' is what app-table usually passes for the 'key'
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            isHovering: false
        }
    },
    computed: {
        items() {
            return this.value;
        }
    }
}
</script>

<style scoped>
.item-cell {
    position: relative;
}
.items-popover {
    position: absolute;
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 0.3rem;
    padding: 0;
    min-width: 250px;
    z-index: 1060; /* Bootstrap popover z-index */
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
    left: 0;
    top: 100%; /* Below the cell content */
    margin-top: 5px;
}
.popover-header {
    padding: 0.5rem 0.75rem;
    margin-bottom: 0;
    font-size: 1rem;
    background-color: #f7f7f7;
    border-bottom: 1px solid #ebebeb;
    border-top-left-radius: calc(0.3rem - 1px);
    border-top-right-radius: calc(0.3rem - 1px);
}
.popover-body {
    padding: 0.75rem;
}
</style>
